import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import DatePicker from "react-datepicker";
import classnames from 'classnames';
import "react-datepicker/dist/react-datepicker.css";

export default class DateComponent extends PureComponent {

  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),
    minDate: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
  };

  state = {
    changedDate: false,
  };

  render = () => <DatePicker
      calendarClassName={classnames({
        [this.props.classes.popper]: true,
        [this.props.classes.keyBoardSelected]: !this.state.changedDate,
      })}
      selected={this.props.value}
      placeholder='Choose time'
      minDate={this.props.minDate}
      dateFormat="MMMM d, yyyy"
      style={{ width: '100% !important' }}
      onChange={(date) => {
        this.setState( {
          changedDate: true,
        });
        this.props.onChange(date);
      }}
      showTimeInput={false}
      autoFocus={false}
      inline
    />;
}
